module.exports = __webpack_public_path__ + "static/media/documents_darkbleu.6b620b82.svg";